import React from 'react';
import FormInput from "../../common/form/form_input";
import FormTextArea from "../../common/form/form_textarea";
import FormPhone from "../../common/form/form_phone";
import FormRecaptcha from "../../common/form/form_recaptcha";
import FormCheckbox from "../../common/form/form_checkbox";
import {Link} from "react-router-dom";
import FormErrorMessage from "../../common/form/form_error_message";
import FormCountrySelectComponent from "../../../js/app/main/app/component/common/form/country_select";
import InfoCardClusterLogin from "../../main/component/info-cards/info-card--cluster-login";
import {_t} from "../../../js/app/common/utils/locale";
import FormLogin from "../../common/form/form_login";
import Config from "../../../js/app/main/app/service/config";

export default function render(props) {
    return (
        <section className="section section-cluster-form section-login">
            <section className="cluster-form-card login-card login-card__sign-up">

                <InfoCardClusterLogin />

                <div className="cluster-form-card__body login-card__form">
                    <header className="cluster-form-card__header">
                        <h2 className="title title--h2">{_t('Cluster Sign up')}</h2>
                    </header>

                    <FormErrorMessage message={this.state.error_message} />

                    <FormLogin
                        name={'login'}
                        label={'Cluster login'}
                        onChange={this.onChangeLogin.bind(this)}
                        errors={this.state.errors.login}
                        labelClass="cluster-login"
                    />
                    <FormInput
                        name={'name'}
                        label={'Cluster name'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.name}
                        labelClass="cluster-name"
                    />
                    <FormInput
                        name={'email'}
                        label={'Email'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.email}
                        labelClass="email"
                    />
                    <FormPhone
                        name={'phone'}
                        label={'Phone'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.phone}
                        labelClass="phone"
                    />
                    <FormCountrySelectComponent
                        name={'country_id'}
                        label={'Country'}
                        value={this.props.defaultCountry}
                        onChange={this.onChangeCountry.bind(this)}
                        errors={this.state.errors.country_id}
                        labelClass="country"
                    />
                    <FormInput
                        name={'vat_number'}
                        label={'Vat number'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.vat_number}
                        labelClass="vat-number"
                    />
                    <FormTextArea
                        name={'description'}
                        label={'Description'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.description}
                        labelClass="description"
                    />

                    {(() => {
                        if (Config.get('is_need_google_authenticator_code')) {
                            return (
                                <FormInput
                                    name={'google_authenticator_code'}
                                    label={'google_authenticator_code_label'}
                                    placeholder={'google_authenticator_code_placeholder'}
                                    onChange={this.onChangeInput.bind(this)}
                                    errors={this.state.errors.google_authenticator_code}
                                    labelClass="google-authenticator-code"
                                />
                            );
                        }
                    })()}

                    <FormRecaptcha
                        label={'Please confirm you are not a robot'}
                        errors={this.state.errors.recaptcha_token}
                        recaptchaKey={this.props.recaptchaKey}
                        onVerify={this.onVerify.bind(this)}
                    />
                    <FormCheckbox
                        label={'Accept %link_start%terms and conditions%link_end%'}
                        labelData={{
                            'link_start': '&nbsp;<a href="https://simplybook.me/en/terms-and-conditions" target="_blank">',
                            'link_end': '</a>'
                        }}
                        name={'terms_accepted'}
                        errors={this.state.errors.terms_accepted}
                        onChange={this.onChangeCheckbox.bind(this)}
                    />

                    <div className="btn-bar">
                        <button className="btn btn--alt btn__signup"  onClick={this.onSubmit.bind(this)}>{_t('Sign up')}</button>
                        <Link to="/" className="link link--primary link--bold btn__reg">{_t('Login')}</Link>
                    </div>
                </div>
                </section>
        </section>
    );
};